import Home from "../views/Home";
import Content from "../views/Content";
import { Edit, Orders } from "../views/orders";
import { ReviewAttributes } from "../views/attributes";
import { ReviewCategories } from "../views/categories";
import { ReviewPartnerManufacturerShowcases } from "../views/partner-manufacturer-showcases";
import ReviewProducts from "../views/products/review/ReviewProducts";
import ReviewNewProducts from "../views/products/reviewNew/ReviewNewProducts";
import ProductAdd from "../views/products/add/ProductAdd";
import ProductCopy from "../views/products/copy/ProductCopy";
import Seo from "../views/Seo";
import Users from "../views/Users";
import ProductEdit from "../views/products/edit/ProductEdit";
import { Buyers, NewUsers, Sellers, UserDetails } from "../views/clients";
import Login from "../views/auth/Login";
import Reports from "../views/reports";

import { access, auth, guest } from "./middlewares";

import noHeaderRoutes from "./noHeaderRoutes";
import noSidebarRoutes from "./noSidebarRoutes";

export { noHeaderRoutes, noSidebarRoutes };

export default {
    mode: "history",
    routes: [
        {
            path: "/",
            component: Home,
            name: "Home",
            meta: {
                middleware: [auth],
            },
        },
        {
            path: "/attributes",
            component: ReviewAttributes,
            name: "ReviewAttributes",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/categories",
            component: ReviewCategories,
            name: "ReviewCategories",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/partner-manufacturer-showcases",
            component: ReviewPartnerManufacturerShowcases,
            name: "PartnerManufacturerShowcases",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/content",
            component: Content,
            name: "Content",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/orders",
            component: Orders,
            name: "Orders",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/orders/edit/:id",
            component: Edit,
            name: "Orders.Edit",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/products",
            component: ReviewProducts,
            name: "Products.List",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/products/new",
            component: ReviewNewProducts,
            name: "Products.NewList",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/products/add",
            component: ProductAdd,
            name: "Products.Add",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/products/copy/:id",
            component: ProductCopy,
            name: "Products.Copy",
            props: true,
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/products/edit/:id",
            component: ProductEdit,
            name: "Products.Edit",
            props: true,
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/seo",
            component: Seo,
            name: "Seo",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/users",
            component: Users,
            name: "Users",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/users/buyers",
            component: Buyers,
            name: "Users.Buyers",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/users/new",
            component: NewUsers,
            name: "Users.New",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/users/sellers",
            component: Sellers,
            name: "Users.Sellers",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/users/details/:id",
            component: UserDetails,
            name: "Users.Details",
            props: true,
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/reports",
            component: Reports,
            name: "Reports",
            meta: {
                middleware: [auth, access],
            },
        },
        {
            path: "/login",
            component: Login,
            name: "Login",
            meta: {
                middleware: [guest],
            },
        },
    ],
};
